var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "shapes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 17c-3.314 0-6 2.686-6 6s2.686 6 6 6c3.314 0 6-2.686 6-6v0c-0.004-3.312-2.688-5.996-6-6h-0zM23 27c-2.209 0-4-1.791-4-4s1.791-4 4-4c2.209 0 4 1.791 4 4v0c-0.003 2.208-1.792 3.997-4 4h-0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3h-12v12h12zM13 13h-8v-8h8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 2.94l-6.699 12.060h13.398zM23 7.060l3.301 5.94h-6.602z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.311 21.438l2.457 7.563h7.951l2.457-7.563-6.434-4.674zM11.266 27h-5.045l-1.559-4.799 4.080-2.965 4.082 2.965z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityShapes);
export default __webpack_public_path__ + "static/media/unity_shapes.0b38c99bd0b783d0f3a5cf5ed4fd706c.svg";
export { ForwardRef as ReactComponent };